import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/atoms/button';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isCcmActionAllowedStatus } from 'utils/userTypeHelper';

const TableActions = ({
  rowIsSaved,
  isEditing,
  new: newRow,
  save,
  cancel,
  saveLabel,
  showTemplateButton,
  onClickTemplateButton,
  disabled,
  isAdminPanel = false,
}) => {
  const patient = useSelector((state) => state.adminPanelPatients.patient);
  const canEditPage = isAdminPanel
    ? true
    : isCcmActionAllowedStatus(patient?.profile?.ccmStatus);
  const [saveLoading, setLoading] = useState(false);
  const isShowBottomLine =
    (rowIsSaved && !saveLoading) ||
    (!rowIsSaved && isEditing) ||
    (saveLoading && isEditing);

  return (
    <>
      {isShowBottomLine && canEditPage && (
        <section className="ccm-table-actions">
          <div className="ccm-table-section__new-row">
            <button onClick={newRow} className="ccm-table-section__new-row-btn">
              + New
            </button>
          </div>
        </section>
      )}

      {canEditPage && (
        <section className="ccm-table-save-panel">
          {showTemplateButton && (
            <Button
              className={classNames({
                'ccm-table-save-panel__btn': true,
                'ccm-table-save-panel__btn--disabled':
                  (rowIsSaved && !isEditing) || saveLoading,
              })}
              onClick={onClickTemplateButton}
              text="Use template"
              disabled={(rowIsSaved && !isEditing) || saveLoading}
            />
          )}

          <Button
            className={classNames({
              'ccm-table-save-panel__btn': true,
              'ccm-table-save-panel__btn--disabled':
                disabled || (rowIsSaved && !isEditing) || saveLoading,
            })}
            onClick={async () => {
              setLoading(true);
              await save();
              setLoading(false);
            }}
            text={saveLabel}
            disabled={disabled || (rowIsSaved && !isEditing) || saveLoading}
          />

          <Button
            className={classNames({
              'ccm-table-save-panel__btn': true,
              'ccm-table-save-panel__btn--disabled':
                (rowIsSaved && !isEditing) || saveLoading,
            })}
            onClick={cancel}
            text="Cancel"
            disabled={(rowIsSaved && !isEditing) || saveLoading}
          />
        </section>
      )}
    </>
  );
};

TableActions.defaultProps = {
  saveLabel: 'Add',
  showTemplateButton: false,
};

TableActions.propTypes = {
  save: PropTypes.func.isRequired,
  new: PropTypes.func,
  onClickTemplateButton: PropTypes.func,
  cancel: PropTypes.func.isRequired,
  rowIsSaved: PropTypes.bool,
  isEditing: PropTypes.bool,
  showTemplateButton: PropTypes.bool,
  saveLabel: PropTypes.string,
  disabled: PropTypes.bool,
  isAdminPanel: PropTypes.bool,
};

export default TableActions;
